import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.StoryFilters;

// initial state
// object name must match specification name
const filters = {
	State: new FormControl.FilterGroup('State', 'Filter by State', 'All States', '', false, true, 'checkbox'),
};

FormControl.assignFilters(filterObj, filters);

export { filters as default };